import React, { useMemo, useState } from "react";
import StripeInput from "components/Shared/StripeInput";
import TextField from "@mui/material/TextField";
import {
  CardCvcElement,
  CardExpiryElement,
  CardNumberElement,
} from "@stripe/react-stripe-js";

const stripeElementStyle = {
  style: {
    base: {
      fontSize: "16px",
    },
  },
};

const CustomCardExpiryElement = (props) => {
  return <CardExpiryElement options={stripeElementStyle} {...props} />
}

const CustomCardNumberElement = (props) => {
  return <CardNumberElement options={{ disableLink: props.disableLink, style: stripeElementStyle.style }} {...props} />
}

const CustomCardCvcElement = (props) => {
  return <CardCvcElement options={stripeElementStyle} {...props} />
}

export const StripeTextField = (props) => {
  const {
    helperText,
    InputLabelProps,
    InputProps = {},
    inputProps,
    error,
    labelErrorMessage,
    stripeElement,
    autoComplete,
    ...other
  } = props;

  return (
    <TextField
      fullWidth
      size="medium"
      InputLabelProps={{
        ...InputLabelProps,
        shrink: true,
      }}
      error={error}
      InputProps={{
        ...InputProps,
        inputProps: {
          ...inputProps,
          ...InputProps.inputProps,
          autoComplete: autoComplete,
          component: stripeElement,
        },
        inputComponent: StripeInput,
      }}
      helperText={error ? labelErrorMessage : helperText}
      {...other}
    />
  );
};

export function StripeTextFieldNumber(props) {
  const [isWebView, setIsWebView] = useState(false);


  const MemoizedCardNumberElement = useMemo(() => {
    const Component = (stripeProps) => (
      <CustomCardNumberElement {...stripeProps} disableLink={isWebView} />
    );
    Component.displayName = "MemoizedCardNumberElement";
    return Component;
  }, [isWebView]);

  return (
    <StripeTextField
      label={`Card Number*`}
      stripeElement={MemoizedCardNumberElement}
      {...props}
      autoComplete="cc-number"
    />
  );
}

export function StripeTextFieldExpiry(props) {
  return (
    <StripeTextField
      label={`Expiration Date*`}
      stripeElement={CustomCardExpiryElement}
      autoComplete="cc-exp"
      {...props}
      autoconfirm="true"
    />
  );
}

export function StripeTextFieldCVC(props) {
  return (
    <StripeTextField
      autoComplete={"cc-csc"}
      label={`CVC*`}
      stripeElement={CustomCardCvcElement}
      {...props}
    />
  );
}
